/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1DocumentCourseDocumentsId202,
  DeleteApiV1DocumentCourseDocumentsId401,
  DeleteApiV1DocumentCourseDocumentsId404,
  DeleteApiV1DocumentCourseDocumentsId500,
  DeleteApiV1DocumentCourseDocumentsIdMutationResponse,
  DeleteApiV1DocumentCourseDocumentsIdPathParams,
} from "../../types/documentCourseDocumentsController/DeleteApiV1DocumentCourseDocumentsId.ts";

export const deleteApiV1DocumentCourseDocumentsIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<DeleteApiV1DocumentCourseDocumentsIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const deleteApiV1DocumentCourseDocumentsId202Schema =
  z.any() as unknown as ToZod<DeleteApiV1DocumentCourseDocumentsId202>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1DocumentCourseDocumentsId401Schema =
  z.any() as unknown as ToZod<DeleteApiV1DocumentCourseDocumentsId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const deleteApiV1DocumentCourseDocumentsId404Schema =
  z.any() as unknown as ToZod<DeleteApiV1DocumentCourseDocumentsId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const deleteApiV1DocumentCourseDocumentsId500Schema =
  z.any() as unknown as ToZod<DeleteApiV1DocumentCourseDocumentsId500>;

export const deleteApiV1DocumentCourseDocumentsIdMutationResponseSchema =
  z.lazy(
    () => deleteApiV1DocumentCourseDocumentsId202Schema,
  ) as unknown as ToZod<DeleteApiV1DocumentCourseDocumentsIdMutationResponse>;
